import { CornerDownLeft } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const ReturnNode = ({ data, selected }: { data: { label: string }; selected?: boolean }) => (
  <NodeShell
    type="return"
    icon={<CornerDownLeft size={16} />}
    label={data.label}
    selected={selected}
    round
  />
);
